import React from 'react';

import { DashboardContentLayout, LocationTabs } from '@portals/framework';
import { TabType } from '@portals/types';

import { SubscriptionsTable } from './SubscriptionsTable';

const TABS: Array<TabType> = [
  {
    id: 'active',
    name: 'active',
    title: 'Active',
    Component: () => (
      <SubscriptionsTable statuses={['active', 'pending_cancellation']} />
    ),
  },
  {
    id: 'suspended',
    name: 'suspended',
    title: 'Suspended',
    Component: () => <SubscriptionsTable statuses={['suspended']} />,
  },
  {
    id: 'canceled',
    name: 'canceled',
    title: 'Canceled',
    Component: () => <SubscriptionsTable statuses={['canceled']} />,
  },
];

export function Subscriptions() {
  return (
    <DashboardContentLayout
      bg="gray.0"
      pageTitle="Subscriptions"
      breadcrumbs={[
        { label: 'Store Management', to: '/store-management' },
        { label: 'Subscriptions' },
      ]}
    >
      <LocationTabs tabs={TABS} />
    </DashboardContentLayout>
  );
}
